export default __webpack_public_path__ + "static/media/Add_Plus_Circle.78d5f8a3.svg";